import { EffectState } from '@/pixi/filters/types'
import * as PIXI from 'pixi.js'
import AudioIntensityAnalyzer from '@/audio/AudioIntensityAnalyzer'
import { SeratoFilter } from '@/pixi/filters/types'
import useAudioEngine from '@/composables/UseAudioEngine'
const { audioBackgroundIntensity } = useAudioEngine()

export abstract class BaseSeratoFilter extends PIXI.Filter implements SeratoFilter{
  constructor (
    protected effectState: EffectState,
    vertexSrc?: string,
    fragmentSrc?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    uniforms?: PIXI.utils.Dict<any>
  ) {
    super(vertexSrc, fragmentSrc, uniforms)
  }

  public abstract updateUniforms(): void

  protected getAudioIntensityValue (): number {
    if (this.uniforms.audioFrequencyData === undefined) {
      return 0
    }

    return AudioIntensityAnalyzer.getAudioIntensity(
      this.uniforms.audioFrequencyData, audioBackgroundIntensity.value
    )
  }

  /**
   * Creates a texture from a resource given by the input URL.
   * If it is a video it will be looped and muted automatically
   * @param url URL to a resource convertible to a texture
   * @returns A PIXI Texture
   */
  protected static urlToTexture (url: string): PIXI.Texture {
    let video: HTMLVideoElement | null = null

    // If a data URL to a video, load a video element manually (PIXI doesn't do it for you)
    if (url.startsWith('data:video')) {
      video = document.createElement('video')
      video.src = url
      video.load()
    }
    const texture = video ? PIXI.Texture.from(video) : PIXI.Texture.from(url)
    const resource = texture.baseTexture.resource

    if (resource instanceof PIXI.VideoResource) {
      resource.source.loop = true
      resource.source.muted = true
    }
    return texture
  }
}
